import { Observable } from 'rxjs';
import { LogEntry } from './log-entry';
import { DecycleLibInterface } from './log.service';

export abstract class LogPublisher {
    location!: string;
    decycleLib!: DecycleLibInterface;
    abstract log(record: LogEntry): Observable<boolean>;
    abstract clear(): Observable<boolean>;
}
